import { gql } from '@apollo/client';

export const GET_GPS_OFFICE_LOCATIONS = gql`
  query GetGpsOfficeLocations {
    getGpsOfficeLocations {
      name
      latitude
      longitude
    }
  }
`;

export const UPDATE_GPS_OFFICE_LOCATIONS = gql`
  mutation UpdateGpsOfficeLocations($locations: [GpsOfficeLocationInput!]!) {
    updateGpsOfficeLocations(locations: $locations)
  }
`;
